import { http } from '@/utils/http'

const state = {
  unreadCount: 0
}

const actions = {
  fetchUnreadCount ({ commit }) {
    return new Promise((resolve, reject) => {
      http('api/member/message/countUnreadMsg', {}, 'get').then(res => {
        if (res.code === '0000') {
          commit('updateUnreadCount', res.data.count)
          resolve()
        } else {
          reject(res.msg)
        }
      }, err => {
        reject(err)
      })
    })
  }
}

const mutations = {
  updateUnreadCount (state, b) {
    state.unreadCount = b
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
